module.exports = __webpack_public_path__ + "img/placeholder.e0ffc6b4.png";